<template>
  <div class="b-select-wrap">
    <div class="b-select-card">
      <h2>选择经营台</h2>
      <p class="sub">本账号绑定了多个经营台，请选择本次进入的业务</p>
      <el-skeleton v-if="loading" :rows="3" animated />
      <div v-else class="list">
        <div
          v-for="b in bindings"
          :key="b.consoleId + '-' + b.subjectId"
          class="item"
          @click="choose(b)"
        >
          <div class="title">{{ b.title }}</div>
          <div class="meta">{{ b.subjectName || b.subjectId }}</div>
        </div>
        <el-empty v-if="!bindings.length" description="暂无可用经营台，请联系平台运营开通" />
      </div>
      <el-button class="mt-12px" @click="$router.push('/store/login')">返回登录</el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { listBConsoleBindings, type BConsoleBindingVO } from '@/api/merchant/b-console'
import { enterAndGo } from '@/views/merchant/registry/gateway'

defineOptions({ name: 'MerchantBSelectConsole' })

const router = useRouter()
const route = useRoute()
const loading = ref(true)
const bindings = ref<BConsoleBindingVO[]>([])

onMounted(async () => {
  try {
    const data = await listBConsoleBindings()
    bindings.value = (data?.bindings || []).filter((b) => b.status === 'ACTIVE')
  } finally {
    loading.value = false
  }
})

async function choose(b: BConsoleBindingVO) {
  const redirect = typeof route.query.redirect === 'string' ? route.query.redirect : undefined
  const accountId = localStorage.getItem('merchantId') || undefined
  await enterAndGo(router, b, accountId, redirect)
}
</script>

<style scoped lang="scss">
.b-select-wrap {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  padding: 24px;
}
.b-select-card {
  width: 480px;
  background: #fff;
  border-radius: 12px;
  padding: 32px;
  h2 {
    margin: 0 0 8px;
  }
  .sub {
    color: #909399;
    margin: 0 0 20px;
    font-size: 14px;
  }
}
.item {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 10px;
  cursor: pointer;
  &:hover {
    border-color: #409eff;
  }
  .title {
    font-weight: 600;
  }
  .meta {
    font-size: 13px;
    color: #909399;
    margin-top: 4px;
  }
}
</style>
